import {createAction} from "@reduxjs/toolkit";

export const setTatabanyaCardContent = createAction('SET_TATABANYA_CARD_CONTENT');